var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferYourFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "high-five_1_",
    "data-name": "high-five (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.33,
    height: 25.451,
    viewBox: "0 0 28.33 25.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87432",
    "data-name": "Group 87432",
    transform: "translate(14.707 3.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275616",
    "data-name": "Path 275616",
    d: "M267.2,160.545v9.5h7.423v-9.005a4.009,4.009,0,0,0-4-4H267.57a4.827,4.827,0,0,1-4.813-4.813A8.282,8.282,0,0,1,261,157.333,8.324,8.324,0,0,0,267.2,160.545Z",
    transform: "translate(-261 -149.125)",
    fill: "#ffded7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275617",
    "data-name": "Path 275617",
    d: "M365.451,99.05a3.957,3.957,0,1,0,3.957-3.957A3.957,3.957,0,0,0,365.451,99.05Z",
    transform: "translate(-359.782 -95.093)",
    fill: "#ffded7",
    fillRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_87433",
    "data-name": "Group 87433",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4975",
    "data-name": "Ellipse 4975",
    d: "M4.5,0A4.5,4.5,0,1,1,0,4.5,4.5,4.5,0,0,1,4.5,0Zm0,7.914A3.414,3.414,0,1,0,1.085,4.5,3.418,3.418,0,0,0,4.5,7.914Z",
    transform: "translate(0 4.079) rotate(-7.99)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87434",
    "data-name": "Group 87434",
    transform: "translate(0.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275618",
    "data-name": "Path 275618",
    d: "M7.966,130.509H.543A.543.543,0,0,1,0,129.966v-9.005a4.545,4.545,0,0,1,4.54-4.54H7.6a4.275,4.275,0,0,0,4.27-4.27,2.3,2.3,0,0,1,4.6,0,8.883,8.883,0,0,1-7.957,8.823v8.992A.543.543,0,0,1,7.966,130.509Zm-6.88-1.085H7.423v-8.4H6a.543.543,0,0,1,0-1.085H7.6a7.793,7.793,0,0,0,7.784-7.784,1.214,1.214,0,0,0-2.429,0A5.362,5.362,0,0,1,7.6,117.507H4.54a3.458,3.458,0,0,0-3.454,3.454Z",
    transform: "translate(0 -105.057)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10942",
    "data-name": "Line 10942",
    d: "M-9.457-7.021A.543.543,0,0,1-10-7.563V-9.457A.543.543,0,0,1-9.457-10a.543.543,0,0,1,.543.543v1.894A.543.543,0,0,1-9.457-7.021Z",
    transform: "translate(23.623 10)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10943",
    "data-name": "Line 10943",
    d: "M-8.511-7.276a.542.542,0,0,1-.471-.271l-.947-1.64a.543.543,0,0,1,.2-.741.543.543,0,0,1,.741.2l.947,1.64a.543.543,0,0,1-.2.741A.54.54,0,0,1-8.511-7.276Z",
    transform: "translate(20.323 10.886)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10944",
    "data-name": "Line 10944",
    d: "M-9.459-7.276a.54.54,0,0,1-.271-.073.543.543,0,0,1-.2-.741l.947-1.64a.543.543,0,0,1,.741-.2.543.543,0,0,1,.2.741l-.947,1.64A.543.543,0,0,1-9.459-7.276Z",
    transform: "translate(25.978 10.886)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275619",
    "data-name": "Path 275619",
    d: "M184.009,314.321h0a.543.543,0,0,1,.478.286l1.136,2.111,2.359.428a.543.543,0,0,1,.3.909l-1.657,1.732.322,2.376a.543.543,0,0,1-.773.562l-2.16-1.04-2.16,1.04a.543.543,0,0,1-.773-.562l.322-2.376-1.657-1.732a.543.543,0,0,1,.3-.909l2.359-.428,1.136-2.111A.543.543,0,0,1,184.009,314.321Zm2.786,3.713-1.623-.294a.543.543,0,0,1-.381-.277l-.782-1.453-.782,1.453a.542.542,0,0,1-.381.277l-1.623.294,1.14,1.192a.543.543,0,0,1,.146.448l-.222,1.635,1.486-.716a.543.543,0,0,1,.471,0l1.486.716-.222-1.635a.543.543,0,0,1,.146-.448Z",
    transform: "translate(-169.844 -298.43)",
    fill: "#fd930d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferYourFriend);
export default __webpack_public_path__ + "static/media/Refer_Your_Friend.17e9864ffd0437f54db7238bddf78c63.svg";
export { ForwardRef as ReactComponent };